<template>
    <div class="extend-panel"
        :class="{
            'extend-panel--text': type === EXTEND_TYPE.TEXTS,
            'extend-panel--img-text': type === EXTEND_TYPE.IMG_TEXTS
        }"
        v-if="isShow">

        <!-- S 纯文本类型 -->
        <div class="text"
            v-if="type === EXTEND_TYPE.TEXTS">
            <div class="text__list">
                <div class="text__item"
                    v-for="(item, index) in extendData"
                    :key="index"
                    @click="clickItem(item)">{{item.name}}</div>
            </div>
        </div>
        <!-- E 纯文本类型 -->

        <!-- S 图文类型 -->
        <div class="img-text"
            v-if="type === EXTEND_TYPE.IMG_TEXTS"
            @click="closePanel">
            <div class="img-text__list"
                @click.prevent.stop>
                <div class="img-text__item"
                    v-for="(item, index) in extendData"
                    :key="index"
                    @click="clickItem(item)">
                    <div class="img-text__icon">
                        <img :src="item.icon"
                            :alt="item.name" />
                    </div>
                    <div class="img-text__name">{{item.name}}</div>
                </div>
            </div>
            <div class="img-text__close icon_close iphone-x-fit-margin"
                @click="closePanel"></div>
        </div>
        <!-- E 图文类型 -->
    </div>
</template>

<script>
    import { sendMessage } from '@/utils/message_send'
    import { EXTEND_TYPE, MESSAGE_NAME } from '@/constants/message'

    export default {
        name: 'TheExtendPanel',
        props : {
            isShow: {
                type: Boolean,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            extendData: {
                type: Array,
                required: true
            }
        },
        data () {
            return {
                EXTEND_TYPE
            }
        },
        methods: {
            clickItem ({ type, content, url }) {
                if (type === 'text') {
                    sendMessage({
                        type: 'base',
                        detailType: MESSAGE_NAME.TEXT,
                        content
                    })
                    this.$eventBus.$emit('showinputstatus', {is_input:true})
                } else if (type === 'url') {
                    window.location.href = url
                }

                this.closePanel()
            },
            closePanel () {
                this.$emit('update:isShow', false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .extend-panel {
        /* &--text {

        } */

        &--img-text {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(#F4F6F7, 0.9);
            z-index: 999;
            overflow: hidden;
        }

        // S 图文类型
        .img-text {
            display: flex;
            align-items: flex-end;
            height: 100%;
            padding-bottom: percent(124);

            &__list {
                display: flex;
                flex-wrap: wrap;
                align-content: flex-end;
                flex-grow: 1;
            }

            &__item {
                flex-grow: 0;
                flex-shrink: 0;
                width: 25%;
                cursor: pointer;

                &:nth-child(n + 5) {
                    margin-top: percent(30);
                }

                &:active {
                    .img-text__icon img {
                        opacity: .7;
                    }
                }
            }

            &__icon {
                width: percent(60, 375 / 4);
                padding-bottom: percent(60, 375 / 4);
                height: 0;
                margin: 0 auto;
                border-radius: 50%;
                box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);

                img {
                    width: 100%;
                }
            }

            &__name {
                margin-top: percent(6, 375 / 4);
                font-size: 14px;
                line-height: (24 / 14);
                text-align: center;
                @include text-line;

                @include iphone4 {
                    font-size: 12px;
                }
            }

            &__close {
                position: absolute;
                right: 16.5px;
                bottom: 13.5px;
                font-size: 22px;
                color: #979797;

                &:active {
                    color: darken(#979797, 7%)
                }
            }
        }
        // E 图文类型

        // S 纯文本类型
        .text {
            &__list {
                border-top: 1px solid #e6e6e6;
                // border-bottom: 1px solid #e6e6e6;
            }

            &__item {
                font-size: 16px;
                color: $primary-text-color;
                text-align: center;
                line-height: 43px;
                cursor: pointer;
                @include text-line;

                &:nth-child(n + 2) {
                    border-top: 1px solid #E6E6E6;
                }

                &:active {
                    background-color: darken(#fff, 7%);
                }
            }
        }
        // E 纯文本类型
    }
</style>
